'use client'

import { Button } from '@/components/ui/button'

export function TemplateChipBar({
  stepIds,
  includeEvent,
  vars = [],
  onInsert,
}: {
  stepIds: string[]
  includeEvent?: boolean
  vars?: string[]
  onInsert: (token: string) => void
}) {
  const tokens = [
    ...stepIds.map((id) => ({ label: `+ Insert \${$${id}}`, value: `\${$${id}}` })),
    ...vars.map((key) => ({ label: `+ Insert \${vars.${key}}`, value: `\${vars.${key}}` })),
    ...(includeEvent ? [{ label: '+ Insert ${$event}', value: '${$event}' }] : []),
  ]

  if (tokens.length === 0) return null

  return (
    <div className="flex flex-wrap gap-2">
      {tokens.map((token) => (
        <Button
          key={token.value}
          type="button"
          variant="outline"
          size="sm"
          className="h-7 rounded-full px-2 text-xs"
          onClick={() => onInsert(token.value)}
        >
          {token.label}
        </Button>
      ))}
    </div>
  )
}
